import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';
import { Group, mapGroup } from './Group';
import { GroupUpdate } from './GroupUpdate';

export interface Result {
	readonly czReimbursement: Group;
}

export const updateGroup = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	update: GroupUpdate
): Promise<Result> => {
	const { reference, productLists } = update;
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-reimbursement-group');

	try {
		const response = await client.fetch(url.expand({ userId, groupId }), {
			method: 'PUT',
			body: JSON.stringify({
				reference: {
					referenceBasketVersion: reference.referenceBasketVersion,
					historicProductDataViewDate:
						reference.historicProductDataViewDate !== null
							? formatApiDate(reference.historicProductDataViewDate)
							: null,
					possibleSavingsRelativeTo: reference.possibleSavingsRelativeTo,
				},
				productLists,
			}),
		});
		const body = await response.json();
		return { czReimbursement: mapGroup(body.czReimbursement) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
